<template>
    <div class="panel master-tables-tool mt-4">
        <div class="table-wrapper">
            <div class="table-panel">
                <div class="panel-item">
                    <strong>{{ this.masterFields.length }}</strong> Fields
                </div>
            </div>
            <div class="table-container">
                <table class="table">
                    <thead>
                    <tr>
                        <th>Field ID</th>
                        <th>Integration Type</th>
                        <th>Table Name</th>
                        <th>Field Alias</th>
                        <th>Field Name</th>
                        <th>Field Type</th>
                        <th>Display Type</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Priority</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="field in masterFields">
                        <td>
                            <a :href="route('metadata.master-fields.edit', field.id)">
                                {{ field.id }}
                            </a>
                        </td>
                        <td>
                            <a :href="route('metadata.integration-types.edit', field.integration_type.id)">
                                {{ field.integration_type.name }}
                            </a>
                        </td>
                        <td>
                            <a :href="route('metadata.master-tables.edit', field.master_table.id)">
                                {{ field.master_table.name }}
                            </a>
                        </td>
                        <td>
                            <a :href="route('metadata.master-fields.edit', field.id)">
                                {{ field.name }}
                            </a>
                        </td>
                        <td>
                            <a :href="route('metadata.master-fields.edit', field.id)">
                                {{ field.nameTranslation }}
                            </a>
                        </td>
                        <td>
                            {{ field.type }}
                        </td>
                        <td>
                            {{ field.display_type }}
                        </td>
                        <td>
                            {{ field.descriptionTranslation }}
                        </td>
                        <td>
                            <span :class="'badge badge-' + (field.status ? 'success' : 'danger')">
                                {{ getStatus(field.status).name }}
                            </span>
                        </td>
                        <td>
                            {{ field.request && field.request.priority ? getPriority(field.request.priority).name : '' }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</template>
<script>

import {MASTER_STATUSES} from "../approval_statuses";
import {METADATA_PRIORITIES} from "../priorities";

export default {
    name: 'table-fields',
    props: {
        masterFields: {
            type: Array,
            required: true,
            default: []
        }
    },
    methods: {
        getStatus(status) {
            return MASTER_STATUSES[status]
        },
        getPriority(priority) {
            return METADATA_PRIORITIES[priority]
        }
    }
}
</script>
